const utils = require('../../../lib/utils')

module.exports = {
    extends: [
        '/',
        'base',
        'form',
        'form',
    ],

    formMapping: {
        cols: [[{
            type: 'fieldGroup',
            source: 'resourceFields'
        }]]
    },

    config: {
        simpleSubForm: true,
        isFullyVertical: true,
    },

    model: {
        fields: [
            {
                fieldCode: 'locationUrl',
                config: {},
                atom: {
                    code: 'locationUrl',
                    dataType: 'text',
                    renderType: 'text'
                },
                dataTEXT: '',
            },
        ],

        config: {
            fields: {
                locationUrl: {
                    langKeys: { // langKeys to use for locationUrl-label, -description and -info
                        label: 'form.fields.location.locationOptions.label',
                        description: 'form.fields.location.locationOptions.description',
                    }
                }
            }
        }
    },

    methods: {
        prepare(storage){
            const fieldConfig = this.model.config || {}
            const langCode = ((storage.user || {}).data || {}).langCode || 'de-at'

            for(const fieldCode in fieldConfig.fields || {}){
                utils.forEach(this.model.fields || [], (field, modelFieldIndex) => {
                    if(field.fieldCode === fieldCode){
                        // hide options which should not be available instead of disabling them.
                        if(field.config.disabled){
                            this.model.fields.splice(modelFieldIndex, 1)
                        } else {
                            utils.refMerge(field.config, fieldConfig.fields[fieldCode])

                            for(const langFlag in field.config.langKeys){
                                const langKey = field.config.langKeys[langFlag]
                                if(langKey && (langFlag === 'label' || langFlag === 'description' || langFlag === 'info')){
                                    field.lang = field.lang || {}
                                    field.lang[langCode] = field.lang[langCode] || {}
                                    field.lang[langCode][langFlag] = utils.i18next.__(langKey)
                                }
                            }
                        }
                        return false
                    }
                })
            }
        },
    },

    hooks: {
        onChildChanged($element, options){
            // keep default form onChildChanged from interfering
            this.triggerClosest('onChildChanged', options)
        }
    }
}